import React from 'react';

const ThankYouPage = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        backgroundColor: '#f9f9f9'
    }}>
        <h1 style={{ color: '#2e7d32' }}>Thank You for Your Purchase!</h1>
        <p style={{ fontSize: '1.2rem', maxWidth: 500, textAlign: 'center' }}>
            We appreciate your business. Your order has been received and is being processed.
            You will receive a confirmation email shortly with your order details.
        </p>
        <a href="/" style={{
            marginTop: 30,
            padding: '10px 24px',
            backgroundColor: '#2e7d32',
            color: '#fff',
            borderRadius: 6,
            textDecoration: 'none',
            fontWeight: 'bold'
        }}>
            Back to Home
        </a>
    </div>
);

export default ThankYouPage;